"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _gsap = require("gsap");

var _Title = require("react-titles/Title6");

var _Title2 = _interopRequireDefault(_Title);

var _HeartIcon = require("./HeartIcon");

var _HeartIcon2 = _interopRequireDefault(_HeartIcon);

var _HeartIcon3 = require("./HeartIcon2");

var _HeartIcon4 = _interopRequireDefault(_HeartIcon3);

var _Flower = require("./Flower");

var _Flower2 = _interopRequireDefault(_Flower);

var _Leaf = require("./Leaf");

var _Leaf2 = _interopRequireDefault(_Leaf);

var _Leaves = require("./Leaves");

var _Leaves2 = _interopRequireDefault(_Leaves);

var _Moon = require("./Moon");

var _Moon2 = _interopRequireDefault(_Moon);

var _Star = require("./Star");

var _Star2 = _interopRequireDefault(_Star);

var _SunFlower = require("./SunFlower");

var _SunFlower2 = _interopRequireDefault(_SunFlower);

var _BaloonsIcon = require("./BaloonsIcon");

var _BaloonsIcon2 = _interopRequireDefault(_BaloonsIcon);

var _Almond = require("./Almond");

var _Almond2 = _interopRequireDefault(_Almond);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var icons = [_HeartIcon2.default, _HeartIcon4.default, _Flower2.default, _Leaf2.default, _Leaves2.default, _Moon2.default, _Almond2.default, _Star2.default, _SunFlower2.default, _BaloonsIcon2.default];

var Scene = function (_Component) {
    _inherits(Scene, _Component);

    function Scene(props) {
        _classCallCheck(this, Scene);

        var _this = _possibleConstructorReturn(this, (Scene.__proto__ || Object.getPrototypeOf(Scene)).call(this, props));

        _initialiseProps.call(_this);

        var _this$props = _this.props,
            scene = _this$props.scene,
            ID = _this$props.ID,
            img = _this$props.img;

        var image = _this.img = new Image();

        _this.state = { scene: scene, prev: ID === scene - 1 };

        _this.svgs = [];
        _this.images = [];
        _this.title = null;
        _this.rects = [];

        image.src = img;
        image.onload = function () {
            _this.setState({ loaded: true });
        };

        _this.shapes = [].concat(_toConsumableArray(Array(8))).map(function (_, i) {
            return [].concat(_toConsumableArray(Array(20))).map(function (_, j) {
                return {
                    Shape: icons[Math.floor(Math.random() * icons.length)],
                    style: {
                        x: -30 + Math.random() * 60,
                        y: -30 + Math.random() * 60,
                        scale: 0.03
                    }
                };
            });
        });
        return _this;
    }

    _createClass(Scene, [{
        key: "componentDidMount",
        value: function componentDidMount() {
            var _props = this.props,
                ID = _props.ID,
                scene = _props.scene;

            if (ID !== scene && ID !== scene - 1) return;

            if (this.props.prev) this.close();else this.open();
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, prevState) {
            var _props2 = this.props,
                ID = _props2.ID,
                scene = _props2.scene;

            if (ID !== scene && ID !== scene - 1) return;

            if (this.state.prev) this.close();else this.open();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var prev = this.state.prev;
            var _props3 = this.props,
                ID = _props3.ID,
                img = _props3.img,
                scene = _props3.scene,
                title = _props3.title,
                subTitle = _props3.subTitle;

            var clipStyle = { clipPath: "url(#" + (prev ? "prev" : "curr") + "-" + ID + ")" };

            if (ID !== scene && ID !== scene - 1) return null;

            return _react2.default.createElement(
                "div",
                { className: "scene" },
                _react2.default.createElement(
                    "svg",
                    { width: "100%", height: "100%", style: { position: "absolute" } },
                    _react2.default.createElement(
                        "defs",
                        null,
                        prev && _react2.default.createElement(
                            "clipPath",
                            { id: "prev-" + ID },
                            _react2.default.createElement("rect", { width: "50%", height: "100%" }),
                            _react2.default.createElement("rect", { x: "50%", width: "50%", height: "100%" })
                        ),
                        !prev && _react2.default.createElement(
                            "clipPath",
                            { id: "curr-" + ID },
                            _react2.default.createElement("rect", { ref: function ref(el) {
                                    return _this2.rects[0] = el;
                                }, width: "50%", height: "100%" }),
                            _react2.default.createElement("rect", { ref: function ref(el) {
                                    return _this2.rects[1] = el;
                                }, x: "50%", width: "50%", height: "100%" })
                        )
                    )
                ),
                _react2.default.createElement(
                    "div",
                    { ref: function ref(el) {
                            return _this2.wrapper = el;
                        }, style: clipStyle },
                    [].concat(_toConsumableArray(Array(8))).map(function (_, id) {
                        return _react2.default.createElement(
                            "svg",
                            {
                                width: "100%",
                                height: "100%",
                                viewBox: "0 0 " + 1500 + " " + 1000,
                                preserveAspectRatio: "xMidYMid slice",
                                ref: function ref(el) {
                                    return _this2.images[id] = el;
                                },
                                key: id,
                                style: {
                                    position: "absolute",
                                    transformOrigin: "50% 50%",
                                    willChange: "transform"
                                } },
                            _react2.default.createElement(
                                "defs",
                                null,
                                _react2.default.createElement(
                                    "filter",
                                    { id: "blur-ellipse" },
                                    _react2.default.createElement("feGaussianBlur", { stdDeviation: "5" })
                                ),
                                _react2.default.createElement(
                                    "filter",
                                    { id: "blur-img-" + id },
                                    _react2.default.createElement("feGaussianBlur", { stdDeviation: id * 0.5 })
                                ),
                                _react2.default.createElement(
                                    "mask",
                                    { id: "mask-" + id },
                                    _react2.default.createElement("rect", { width: "100%", height: "100%", fill: "#fff" }),
                                    _react2.default.createElement("ellipse", {
                                        filter: "url(#blur-ellipse)",
                                        cx: "50%",
                                        cy: "50%",
                                        rx: 45 - (7 - id) * 3 + "%",
                                        ry: 45 - (7 - id) * 2 + "%"
                                    })
                                )
                            ),
                            _react2.default.createElement("image", {
                                filter: "url(#blur-img-" + id + ")",
                                mask: id === 0 ? "none" : "url(#mask-" + id + ")",
                                href: img,
                                width: "100%",
                                height: "100%"
                            }),
                            id === 2 && _react2.default.createElement(_Title2.default, {
                                x: "25%",
                                y: "30%",
                                innerRef: function innerRef(el) {
                                    return _this2.title = el;
                                },
                                size: 200,
                                text1: title,
                                text2: subTitle,
                                fontFamily: "monospace",
                                open: !prev
                            }),
                            id > 0 && _this2.shapes[id].map(function (_ref, i) {
                                var Shape = _ref.Shape,
                                    style = _ref.style;
                                return _react2.default.createElement(Shape, { key: i, style: _this2.iconStyle(style) });
                            })
                        );
                    })
                )
            );
        }
    }]);

    return Scene;
}(_react.Component);

Scene.getDerivedStateFromProps = function (_ref2, prevState) {
    var scene = _ref2.scene,
        ID = _ref2.ID;

    if (scene !== prevState.scene) {
        return { prev: ID === scene - 1 };
    }

    return null;
};

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.close = function () {
        _this3.images.forEach(function (img, id) {
            var timeline = new _gsap.TimelineMax();

            timeline.fromTo(img, 5, { transformPerspective: 500, z: (8 - id) * -1000 + 2000, scale: 1 + (8 - id) * 2 }, { z: "-=2000" });
        });
    };

    this.open = function () {
        var timeline3 = new _gsap.TimelineMax();
        timeline3.fromTo(_this3.wrapper, 3, { willChange: "opacity", opacity: 0 }, { opacity: 1 });

        _this3.images.forEach(function (img, id) {
            var timeline = new _gsap.TimelineMax();
            var timeline2 = new _gsap.TimelineMax({ delay: 2 });

            timeline.fromTo(img, 2, { transformPerspective: 500, y: 1000 - 100 * (8 - id), rotationX: (id + 1) * -5, z: 0, scale: 1 }, { y: 0, rotationX: 0, z: 0, scale: 1 });
            timeline2.fromTo(img, 5, { transformPerspective: 500, z: (8 - id) * -1000, scale: 1 + (8 - id) * 2 }, { z: "+=2000" });
        });

        var timeline = new _gsap.TimelineMax();

        timeline.fromTo(_this3.rects[0], 2, { y: 900, skewX: 25 }, { y: 0, skewX: 0 }).fromTo(_this3.rects[1], 2, { y: 900, skewX: -25 }, { y: 0, skewX: 0 }, "-=2");
    };

    this.iconStyle = function (_ref3) {
        var x = _ref3.x,
            y = _ref3.y,
            scale = _ref3.scale;
        return {
            transform: "translate(" + x + "%, " + y + "%)  scale(" + scale + ")",
            transformOrigin: "50% 50%"
        };
    };
};

exports.default = Scene;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-parallax-3d/index.js
// module id = 76
// module chunks = 0